module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/issues/issues.component.css
// module id = ./src/app/issues/issues.component.css
// module chunks = main